import React from "react";
import { Route, Redirect } from "react-router-dom";

import AlunoAvaliacao from  "@/pages/Aluno/Avaliacoes/Avaliacao";
import EmpresaAvaliacao from  "@/pages/Empresa/Avaliacoes/Avaliacao";
import Login from "@/pages/Auth/Login";

export default function AvaliacaoRoute({ auth, ...rest }) {
  // idenficar se o usuario está logado
  const { authenticated, data } = auth;

  if (!authenticated) {
    return (
      <Route
        {...rest}
        render={props => <Redirect to={{ pathname: "/login" }} />}
      />
    );
  }

  const { tipo } = data;
  let Component;

  switch (true) {
    case tipo === "aluno":
      Component = AlunoAvaliacao;
      break;
    case ["funcionario", "supervisor"].includes(tipo):
      Component = EmpresaAvaliacao;
      break;
    default: Component = Login;
  }

  return <Route {...rest} render={props => <Component {...props} />} />;
}
